module.exports = __webpack_public_path__ + "static/average-age-overall-802e8fd3d82debdc9833c903803e52a1.svg";